var render, staticRenderFns
import script from "./ClickableTitleMixin.vue?vue&type=script&lang=js&"
export * from "./ClickableTitleMixin.vue?vue&type=script&lang=js&"
import style0 from "./ClickableTitleMixin.vue?vue&type=style&index=0&id=7d2cc46e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2cc46e",
  null
  
)

export default component.exports